// src/components/charts/BarChart.jsx
import React from 'react';
import { AgCharts } from 'ag-charts-react';

/**
 * Componente BarChart con ag-Charts
 * @param {Object} props
 * @param {Array} props.data - Datos del gráfico
 * @param {String} props.xKey - Key para eje X (categorías)
 * @param {Array} props.series - Series a mostrar
 * @param {String} props.title - Título del gráfico
 * @param {Number} props.height - Altura del gráfico (default: 400)
 * @param {Boolean} props.stacked - Si es apilado (default: false)
 * @param {Boolean} props.horizontal - Si es horizontal (default: false)
 */
const BarChart = ({
  data = [],
  xKey = 'category',
  series = [],
  title = '',
  height = 400,
  stacked = false,
  horizontal = false,
}) => {
  const options = {
    data,
    title: title ? { text: title } : undefined,
    series: series.map((s) => ({
      type: 'bar',
      xKey,
      yKey: s.yKey,
      yName: s.name || s.yKey,
      fill: s.color || undefined,
      stacked,
    })),
    axes: [
      {
        type: 'category',
        position: horizontal ? 'left' : 'bottom',
      },
      {
        type: 'number',
        position: horizontal ? 'bottom' : 'left',
      },
    ],
    legend: {
      position: 'bottom',
    },
  };

  return (
    <div style={{ height }}>
      <AgCharts options={options} />
    </div>
  );
};

export default BarChart;